import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { mapOrganizationDollyFieldsToBody } from './mappers';
import type { OrganizationDollyEnvelope, OrganizationDollyFields } from './types';

export async function createOrganizationDolly(organizationId: string, fields: OrganizationDollyFields = {}) {
  const url = `/web/studio/organizations/${organizationId}/dolly`;

  const response = await api.executePostRequest<ObjectResponse<OrganizationDollyEnvelope>>(
    url,
    mapOrganizationDollyFieldsToBody(fields)
  );

  return response.data;
}
